import { Component, forwardRef, HostListener, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'underscore';

@Component({
    standalone: false,
    selector: 'res-custom-input',
    templateUrl: './custom-input.component.html',
    styleUrls: ['./custom-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomInputComponent),
            multi: true
        }
    ]
})
export class CustomInputComponent implements OnInit {
    @Input() field: any;
    @Input() automationId = '';
    @Input() placeholderField: string;
    @Input() customWidth: string;
    @Input() iconClass: string;
    @Input() iconColor: string;
    @Input() inputButtonHidden = true;
    @Input() queryFocusChanged: () => void;
    @Input() openTargetPicker: () => void;
    @Input() excludeTrashBtnFromTabIndex = true;
    @Input() hideClearBtn = false;
    @Input() isFieldDisabled = false;
    @Input() inputType = 'text';
    @Input() inputNumberMaxLength = 10;
    @Input() inputNumberMinValue = 0;
    @Input() inputNumberMaxValue = null;

    @HostListener("input", ["$event.target.value"])
    onInput(value) {
        if (this.isNumberMode() && value && this.field?.value) {
            if (this.inputNumberMaxLength > 0 && value.length > this.inputNumberMaxLength) {
                this.field.value = value.slice(0, this.inputNumberMaxLength);
            }
            const intValue = parseInt(value, 10);
            if (intValue < this.inputNumberMinValue) {
                this.field.value = this.inputNumberMinValue;
            }
            if (this.inputNumberMaxValue && intValue > this.inputNumberMaxValue) {
                const auxValue = value.slice(0, this.inputNumberMaxLength);
                this.field.value = auxValue > this.inputNumberMaxValue ? auxValue.slice(0, this.inputNumberMaxLength - 1) : auxValue;
            }
        }
    }

    ngOnInit(): void {
        if (!this.field) {
            this.field = { value: '' };
        }
    }

    onFocusOut(input): void {
        if (!input?.value && this.isNumberMode() && this.field && !this.placeholderField) {
            this.field.value = this.inputNumberMinValue;
            this.queryFocusChange();
        }
    }

    isNumberMode(): boolean {
        return this.inputType === 'number';
    }

    hasValue(item): any {
        if (this.hideClearBtn) {
            return false;
        } else {
            if (item) {
                return !_.isEmpty(item.value);
            }
            return false;
        }
    }

    hasFilterValue(): boolean {
        return this.field?.value && this.field.filterApplied;
    }

    queryFocusChange(): void {
        if (this.queryFocusChanged) { this.queryFocusChanged(); }
    }

    openGenericTargetPicker(): void {
        if (this.openTargetPicker) { this.openTargetPicker(); }
    }

    onKeypressEvent(event: any) {
        if (this.isNumberMode()) {
            // allow only numbers to be entered
            if (event) {
                const allowOrSkipZero = (this.inputNumberMinValue > 0 && event.charCode === 48 && !this.field.value) ? false : event.charCode >= 48;
                return (event.charCode == 8 || event.charCode == 0) ? null : allowOrSkipZero && event.charCode <= 57;
            }
        }
        return;
    }
}
